import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as RewardService from '_services/rewards-service';

const initialState = {
  analytics: null,
  transactions: {},
  transactionCount: 0,
  status: 'idle',
  error: null,
};

// fetch analytics data 
export const getAnalytics = createAsyncThunk('analytics/getAnalytics', async (object) => {
  return RewardService.getProductAnalytics(object);
})

// fetch analytics data 
export const getTransactions = createAsyncThunk('analytics/getTransactions', async (object) => {
  return RewardService.getProductTransactions(object);
})

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    reset: (state) => initialState,
    setTransaction: (state, action) => {
      return {
        ...state,
        selectedTransaction: action?.payload,
      }
    }
  },
  extraReducers: {
    [getAnalytics.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
      }
    },
    [getAnalytics.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        analytics: action.payload,
      }
    },
    [getAnalytics.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        error: action.error.message,
      }
    },
    [getTransactions.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
      }
    },
    [getTransactions.fulfilled]: (state, action) => {

      return {
        ...state,
        status: 'succeeded',
        transactions: action.payload?.transactions,
        transactionCount: action.payload?.totalCount,
      }
    },
    [getTransactions.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        error: action.error.message,
      }
    },

  }
});

export const { setTransaction, reset } = analyticsSlice.actions;

export const selectSelectedTransaction = state => state.analytics.selectedTransaction;
export const selectAnalytics = state => state.analytics.analytics;
export const selectTransactions = state => state.analytics.transactions;
export const selectTransactionStatus = state => state.analytics.status;
export const selectTransactionTotalCount = state => state.analytics.transactionCount;

export default analyticsSlice.reducer;
